<template>
    <div class="zenify-container" :class="{ 'popup-mode': isPopupMode }">
        <div class="dialer" v-if="isPopupMode || showDialer">
            <!-- Header -->
            <div class="dialer-header">
                <div class="header-content">
                    <div class="user-section">
                        <div class="user-avatar">
                            <i class="fas fa-user-circle"></i>
                        </div>
                        <div class="user-details">
                            <p class="user-name">{{userInfo?.name || 'Agent'}}</p>
                            <div class="status-indicator">
                                <span class="status-dot"></span>
                                <span class="status-text">Connected</span>
                            </div>
                        </div>
                    </div>
                    <button class="close-btn" @click="closeDialer" title="Đóng">
                        <i class="fas fa-times"></i>
                    </button>
                </div>
            </div>

            <!-- Dialer Content -->
            <div class="dialer-content">
                <!-- Keypad Interface -->
                <div v-if="ended && incomingCall" class="keypad-section">
                    <div class="phone-display">
                        <div class="phone-prefix">+84</div>
                        <input
                            v-model="phoneModel"
                            type="text"
                            class="phone-input"
                            maxlength="10"
                            placeholder="9 1234 5678"
                            @keydown="onKeydown"
                            @input="onInput"
                        />
                        <button class="clear-btn" @click="closePhone" v-if="phoneModel" title="Xóa">
                            <i class="fas fa-backspace"></i>
                        </button>
                    </div>

                    <div class="keypad-grid">
                        <button v-for="key in keys" :key="key.label" @click="appendNumber(key.value)" class="keypad-btn">
                            <span class="key-number">{{ key.value }}</span>
                            <span v-if="key.sub" class="key-letters">{{ key.sub }}</span>
                        </button>
                    </div>

                    <div class="call-controls">
                        <button class="control-icon-btn" title="Danh bạ">
                            <i class="fas fa-list"></i>
                        </button>
                        <button class="call-action-btn" @click="makeCall" :disabled="!phoneModel" title="Gọi điện">
                            <i class="fas fa-phone"></i>
                        </button>
                        <button class="control-icon-btn" title="Liên hệ">
                            <i class="fas fa-user"></i>
                        </button>
                    </div>
                </div>

                <!-- Incoming Call Interface -->
                <div v-else-if="!ended && !incomingCall" class="call-section incoming">
                    <div class="call-header">
                        <h3 class="call-title">Cuộc gọi đến</h3>
                        <div class="call-timer" v-if="waitTime">
                            <i class="fas fa-clock"></i>
                            {{ formatWaitTime() }}
                        </div>
                    </div>

                    <div class="call-info-block">
                        <div class="caller-avatar-large pulse">
                            <img src="/media/call-center.png" alt="Caller" />
                        </div>
                        <p class="calling-status">Đang gọi đến...</p>
                        <p class="caller-number">{{ caller }}</p>
                        <p class="caller-details">Từ: {{ caller }}</p>
                    </div>

                    <div class="call-actions-group">
                        <button class="action-btn decline" @click="terminate" title="Từ chối">
                            <i class="fas fa-phone-slash"></i>
                            <span>Từ chối</span>
                        </button>
                        <button class="action-btn accept" @click="acceptIncomingCall" title="Trả lời">
                            <i class="fas fa-phone"></i>
                            <span>Trả lời</span>
                        </button>
                    </div>
                </div>

                <!-- Active Call Interface -->
                <div v-else-if="!ended && incomingCall" class="call-section active">
                    <div class="call-header">
                        <h3 class="call-title">{{ title }}</h3>
                        <div class="call-timer duration" v-if="callTime">
                            <i class="fas fa-stopwatch"></i>
                            {{ formatCallTime() }}
                        </div>
                    </div>

                    <div class="via-info">
                        <span class="via-label">Thông qua</span>
                        <span class="via-number">19004455</span>
                    </div>

                    <div class="call-info-block">
                        <div class="caller-avatar-large">
                            <img src="/media/call-center.png" alt="Caller" />
                        </div>
                        <p class="caller-number">{{ phoneNumber }}</p>
                        <p class="wait-info" v-if="waitTime">
                            <i class="fas fa-hourglass-end"></i>
                            Chờ: {{ waitTime }}s
                        </p>
                    </div>

                    <div class="call-actions-group">
                        <button class="action-btn end-call" @click="terminate" title="Kết thúc">
                            <i class="fas fa-phone-slash"></i>
                            <span>Kết thúc</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {SET_BREADCRUMB} from "../../../../core/services/store/breadcrumbs.module";
import {CONNECT_ZENIFY, POST_LOG_ZENIFY} from "../../../../core/services/store/user/ticket.module";
import {mapActions} from "vuex";
import {sendZenifyMessage, subscribeZenifyMessages} from "@/core/services/zenifyChannel";

export default {
    name: "ZenifyIndex",
    props: {
        showDialer: {
            type: Boolean,
            default: false
        },
        phoneNumber: {
            type: String,
            default: ''
        },
        isPopup: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            localPhone: this.phoneNumber || '',
            token: '',
            userInfo: [],
            idDelete: '',
            callProfile: "Number-1",
            callDisplayNumber: "+84899199999",
            keys: [
                {value: "1"},
                {value: "2", sub: "ABC"},
                {value: "3", sub: "DEF"},
                {value: "4", sub: "GHI"},
                {value: "5", sub: "JKL"},
                {value: "6", sub: "MNO"},
                {value: "7", sub: "PQRS"},
                {value: "8", sub: "TUV"},
                {value: "9", sub: "WXYZ"},
                {value: "*"},
                {value: "0", sub: "+"},
                {value: "#"},
            ],
            checkCallInbound: false,
            ended: true,
            callId: '',
            callerName: '',
            callDuration: '',
            waitTime: 0,
            callTime: 0,
            callerTitle: '',
            incomingCall: true,
            caller: '',
            interval: null,
            intervalCallTime: null,
            title: 'Cuộc gọi đi',
            audioRing: null,
            audioPlayPromise: null,
            isZenifyReady: false,
            pendingCallPhone: null,
            unsubscribeChannel: null
        }
    },
    beforeDestroy() {
        this.stopIncomingCallAudio();
        clearInterval(this.interval);
        clearInterval(this.intervalCallTime);
        if (this.unsubscribeChannel) {
            this.unsubscribeChannel();
        }
        window.removeEventListener('beforeunload', this.handleBeforeUnload);
        sendZenifyMessage({ type: 'POPUP_CLOSED' });
    },
    mounted() {
        if (this.phoneNumber) {
            this.localPhone = this.phoneNumber;
        } else if (this.$route?.query?.phone) {
            this.localPhone = this.$route.query.phone;
            this.pendingCallPhone = this.$route.query.phone;
        }

        this.initAudio();
        this.getToken();

        // Lắng nghe lệnh từ các tab CRM khác
        this.unsubscribeChannel = subscribeZenifyMessages((msg) => {
            if (msg.type === 'DIAL' && msg.phone) {
                this.phoneModel = msg.phone;
                try { window.focus(); } catch (e) {}
                if (this.isZenifyReady) {
                    this.makeCall();
                } else {
                    this.pendingCallPhone = msg.phone;
                }
            } else if (msg.type === 'PING') {
                sendZenifyMessage({
                    type: 'PONG',
                    isConnected: this.isZenifyReady,
                    userInfo: this.userInfo,
                    inCall: !this.ended
                });
            } else if (msg.type === 'FOCUS') {
                try {
                    window.focus();
                } catch (e) {}
                const prevTitle = document.title;
                document.title = "📞 [TỔNG ĐÀI ĐANG MỞ] " + prevTitle;
                setTimeout(() => {
                    document.title = prevTitle;
                }, 2000);
            }
        });

        window.addEventListener('beforeunload', this.handleBeforeUnload);
    },
    methods: {
        ...mapActions('zenify', ['openWithPhone', 'close', 'setEndPhone', 'open']),
        handleBeforeUnload() {
            sendZenifyMessage({ type: 'POPUP_CLOSED' });
            if (!this.ended && window.ZenifyApp) {
                try {
                    window.ZenifyApp.terminate();
                } catch (e) {}
            }
        },
        getToken()
        {
            this.$store.dispatch(CONNECT_ZENIFY).then((res) => {
                const resData = res?.data?.data || res?.data;
                if (resData) {
                    this.userInfo = resData.info;
                    const token = resData.token;
                    if (window.ZenifyApp && token) {
                        window.ZenifyApp.subscribe(this.onAppEvent);
                        window.ZenifyApp.init(token);
                        this.changeAgentStatus();
                        this.activateVoice();
                        this.isZenifyReady = true;
                        sendZenifyMessage({
                            type: 'PONG',
                            isConnected: true,
                            userInfo: this.userInfo,
                            inCall: !this.ended
                        });
                        if (this.pendingCallPhone) {
                            this.phoneModel = this.pendingCallPhone;
                            this.makeCall();
                            this.pendingCallPhone = null;
                        }
                    }
                }
            }).catch((err) => {
                console.error("Error connecting to Zenify:", err);
            });
        },
        postLogZenify(content)
        {
            let payload = {
                "callId": this.callId,
                "content": content,
                "ticketId": this.$route.params.id
            };

            this.$store.dispatch(POST_LOG_ZENIFY, payload).catch((err) => {
                console.error("Error posting log Zenify:", err);
            });
        },
        activateVoice() {
            ZenifyApp.activateVoice();
        },
        changeAgentStatus()
        {
            var request = {status: 'AVAILABLE'};
            ZenifyApp.changeAgentStatus(request);
        },
        appendNumber(num) {
            this.$emit('appendNumber', num)
            this.phoneModel += num;
        },
        onKeydown(e) {
            const allowKeys = [
                'Backspace',
                'Delete',
                'ArrowLeft',
                'ArrowRight',
                'Tab'
            ]

            if (e.ctrlKey || e.metaKey) return

            if (allowKeys.includes(e.key)) return

            if (!/[0-9]/.test(e.key)) {
              e.preventDefault()
            }
        },
        onInput(e) {
            const value = e.target.value.replace(/\D/g, '').slice(0, 11)
            this.phoneModel = value
            this.openWithPhone(value)
            this.$emit('update:phoneNumber', value)
        },
        makeCall() {
            if (!this.phoneModel)
            {
                return;
            }
            this.ended = false;
            this.incomingCall = true;
            if (window.ZenifyApp) {
                window.ZenifyApp.dialCall(this.phoneModel);
                console.log("Đang gọi:", this.phoneModel);
            } else {
                console.warn("ZenifyApp chưa được khởi tạo!");
            }
        },
        closePhone() {
            this.$emit('closePhone');
        },
        closeDialer()
        {
          if (this.isPopupMode) {
              if (!this.ended) {
                  if (confirm('Cuộc gọi đang diễn ra. Bạn có chắc muốn ngắt cuộc gọi và đóng cửa sổ?')) {
                      this.terminate();
                      window.close();
                  }
              } else {
                  window.close();
              }
          } else {
              this.close();
          }
        },
        startCount() {
            this.waitTime = 0;
            clearInterval(this.interval);

            this.interval = setInterval(() => {
                if (this.waitTime < 60) {
                    this.waitTime++;
                } else {
                    clearInterval(this.interval);
                }
            }, 1000);
        },
        beforeDestroyCallTime() {
            clearInterval(this.intervalCallTime);
        },
        startCountCallTime()
        {
            if (this.intervalCallTime) return;

            this.intervalCallTime = setInterval(() => {
                this.callTime++;
            }, 1000);
        },
        formatCallTime() {
            const hours = Math.floor(this.callTime / 3600);
            const minutes = Math.floor((this.callTime % 3600) / 60);
            const seconds = this.callTime % 60;

            const pad = (num) => String(num).padStart(2, '0');
            return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
        },
        formatWaitTime() {
            const minutes = Math.floor(this.waitTime / 60);
            const seconds = this.waitTime % 60;
            const pad = (num) => String(num).padStart(2, '0');
            return `${pad(minutes)}:${pad(seconds)}`;
        },
        beforeDestroy() {
            clearInterval(this.interval);
        },
        initAudio() {
            if (!this.audioRing) {
                this.audioRing = new Audio('/media/incoming-call.mp3');
                this.audioRing.loop = true;
                this.audioRing.load();
            }
        },
        playIncomingCallAudio() {
            try {
                this.initAudio();
                this.audioRing.currentTime = 0;
                this.audioPlayPromise = this.audioRing.play();
                if (this.audioPlayPromise !== undefined) {
                    this.audioPlayPromise.catch((error) => {
                        if (error.name === 'AbortError') {
                            // Bỏ qua lỗi ngắt do pause/stop xảy ra ngay sau play
                            return;
                        }
                        if (error.name === 'NotAllowedError') {
                            console.warn('Trình duyệt chặn autoplay âm thanh khi chưa có tương tác:', error);
                            return;
                        }
                        console.warn('Không thể tự động phát âm thanh cuộc gọi đến:', error);
                    });
                }
            } catch (error) {
                console.error('Lỗi khi phát âm thanh cuộc gọi đến:', error);
            }
        },
        stopIncomingCallAudio() {
            try {
                if (this.audioRing) {
                    if (this.audioPlayPromise !== undefined && this.audioPlayPromise !== null) {
                        this.audioPlayPromise
                            .then(() => {
                                if (this.audioRing) {
                                    this.audioRing.pause();
                                    this.audioRing.currentTime = 0;
                                }
                            })
                            .catch(() => {})
                            .finally(() => {
                                this.audioPlayPromise = null;
                            });
                    } else {
                        this.audioRing.pause();
                        this.audioRing.currentTime = 0;
                    }
                }
            } catch (error) {
                console.error('Lỗi khi tắt âm thanh cuộc gọi đến:', error);
            }
        },
        onAppEvent(msg) {
            this.callId = msg?.data?.callId ? msg?.data?.callId : '';
            switch (msg.objectId) {
                case ZenifyConfig.CALL_DETAIL_RESPONSE_ID:
                    console.log('chi tiets')
                    break;
                case ZenifyConfig.RING_AGENT_RESPOND_ID: {
                    const { callId, caller, callType, queueId, called } = msg.data;
                    console.log(`Có cuộc gọi đến từ ${caller}`);
                    this.title = 'Cuộc gọi đến';
                    this.startCount();
                    this.ended = false;
                    this.incomingCall = false;
                    this.caller = caller;
                    this.playIncomingCallAudio();
                    this.open();
                    try { window.focus(); } catch (e) {}
                    sendZenifyMessage({
                        type: 'INCOMING_CALL',
                        caller: caller,
                        callId: callId
                    });
                    break;
                }

                case ZenifyConfig.AGENT_ANSWER_RESPOND_ID: {
                    this.stopIncomingCallAudio();
                    this.ended = false;
                    this.beforeDestroy();
                    this.incomingCall = true;
                    this.startCountCallTime();
                    this.waitTime = 0;
                    console.log("Agent đã trả lời cuộc gọi");
                    sendZenifyMessage({
                        type: 'CALL_ANSWERED',
                        caller: this.caller,
                        callId: this.callId
                    });
                    break;
                }

                case ZenifyConfig.AGENT_END_CALL_RESPOND_ID: {
                    this.stopIncomingCallAudio();
                    this.terminate();
                    console.log("Agent đã kết thúc cuộc gọi");
                    this.postLogZenify(`Có cuộc gọi đến từ ${this.caller}`)
                    sendZenifyMessage({
                        type: 'CALL_ENDED',
                        callId: this.callId
                    });
                    break;
                }

                case ZenifyConfig.USER_END_CALL_RESPOND_ID: {
                    this.stopIncomingCallAudio();
                    this.terminate();
                    console.log("Khách hàng đã kết thúc cuộc gọi");
                    this.beforeDestroy();
                    this.beforeDestroyCallTime();
                    this.phoneModel = '';
                    sendZenifyMessage({
                        type: 'CALL_ENDED',
                        callId: this.callId
                    });
                    break;
                }

                case ZenifyConfig.END_CALL_RESPOND_ID: {
                    this.stopIncomingCallAudio();
                    console.log("Cuộc gọi đã kết thúc hoàn toàn");
                    this.phoneModel = '';
                    sendZenifyMessage({
                        type: 'CALL_ENDED',
                        callId: this.callId
                    });
                    break;
                }

                case ZenifyConfig.NEW_NOTIFICATION_ID: {
                    this.stopIncomingCallAudio();
                    const { type, title } = msg.data;
                    let message = '';
                    if (type === "agent_reject") {
                        message = "Bạn đã từ chối cuộc gọi nhiều lần!";
                        console.warn("Bạn đã từ chối cuộc gọi nhiều lần!");
                    } else if (type === "phone_failed") {
                        message = "Lỗi gọi điện thoại:";

                        console.error("Lỗi gọi điện thoại:", title);
                    } else {
                        console.log("Notification:", msg.data);
                    }

                    break;
                }

                case ZenifyConfig.OUTCALL_ERROR_RESPONSE_ID: {
                    const errCode = Number(msg.data.errorCode);
                    let errMessage = this.mapErrorCode(errCode);
                    console.error("Lỗi gọi ra:", errMessage);
                    break;
                }

                case ZenifyConfig.OUT_CALL_RESPONSE_ID: {
                    if (msg.data.errorCode === "OK") {
                        console.log("Cuộc gọi ra thành công!");
                    } else {
                        console.error("Gọi ra thất bại:", msg.data.errorCode);
                    }
                    break;
                }

                case ZenifyConfig.CHANGE_AGENT_STATUS_RESPOND_ID: {
                    const { status, agentId, errorcode } = msg.data;
                    if (Number(errorcode) === 0) {
                        console.log(`Agent ${agentId} đổi trạng thái: ${status}`);
                        if (status === "LOGOUT") {
                            console.warn("Bạn đã bị đăng xuất khỏi hệ thống!");
                            window.ZenifyApp.logout();
                        }
                    }
                    break;
                }

                default:
                    console.log("Sự kiện khác:", msg);
                    break;
            }
        },
        mapErrorCode(code) {
            const errors = {
                401: "Không thể gọi ra: chưa đăng ký tổng đài với Hub",
                402: "Hết hạn mức cước",
                403: "Hub từ chối cuộc gọi (IP chưa khai báo)",
                404: "Không có routing rule",
                408: "Không có phản hồi",
                420: "Số điện thoại không đúng định dạng",
                480: "Thuê bao không liên lạc được",
                486: "Thuê bao bận",
                500: "Hệ thống Telco gặp sự cố",
                503: "Hub gặp sự cố, thử lại sau",
                603: "Số bị khóa bởi mạng người nhận",
                607: "Khách hàng từ chối nhận cuộc gọi",
                608: "Hệ thống quá tải, thử lại sau",
            };
            return errors[code] || `Lỗi không xác định (mã ${code})`;
        },
        logout()
        {
            window.ZenifyApp.logout();
        },
        rejectIncomingCall() {
            console.log("Từ chối cuộc gọi từ:", this.caller);
            this.stopIncomingCallAudio();
            this.ended = true;
            this.incomingCall = false;
            this.waitTime = 0;
            this.beforeDestroy();
            if (window.ZenifyApp) {
                window.ZenifyApp.rejectCall();
            }
            this.postLogZenify(`Từ chối cuộc gọi từ ${this.caller}`);
        },
        acceptIncomingCall() {
            console.log("Trả lời cuộc gọi từ:", this.caller);
            this.stopIncomingCallAudio();
            this.ended = false;
            this.incomingCall = true;
            this.waitTime = 0;
            this.startCountCallTime();
            if (window.ZenifyApp) {
                window.ZenifyApp.answerCall();
            }
        },
        rejectCall()
        {

        },
        acceptCall()
        {

        },
        queue()
        {
            return ''
        },
        answerCall()
        {
            this.stopIncomingCallAudio();
            console.log(ZenifyApp)
            ZenifyApp.answerCall();
        },
        terminate()
        {
            this.stopIncomingCallAudio();
            this.ended = true;
            this.incomingCall = true;
            this.phoneModel = '';
            this.beforeDestroy();
            this.beforeDestroyCallTime();
            this.callTime = 0;
            this.resetLogs();
            ZenifyApp.terminate();
        },
        resetLogs()
        {
            setTimeout(() => {
                this.setEndPhone();
            },1000);
        }
    },
    watch: {
        phoneNumber(newVal) {
            if (newVal !== undefined) {
                this.localPhone = newVal;
            }
        }
    },
    computed: {
        isPopupMode() {
            return this.isPopup || this.$route?.name === 'zenify-dialer';
        },
        phoneModel: {
            get() {
                return this.localPhone;
            },
            set(val) {
                const clean = val ? String(val).replace(/\D/g, '').slice(0, 10) : '';
                this.localPhone = clean;
                this.$emit('update:phoneNumber', clean);
            }
        }
    }
}
</script>

<style>
/* Modern Color Palette */
:root {
    --primary: #2563eb;
    --primary-light: #60a5fa;
    --primary-dark: #1e40af;
    --success: #059669;
    --success-light: #10b981;
    --danger: #dc2626;
    --danger-light: #ef4444;
    --bg-primary: #ffffff;
    --bg-secondary: #f8fafc;
    --bg-tertiary: #f1f5f9;
    --border-color: #e2e8f0;
    --text-primary: #0f172a;
    --text-secondary: #64748b;
    --text-tertiary: #94a3b8;
    --shadow-sm: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
    --shadow-md: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
    --shadow-lg: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
    --shadow-xl: 0 20px 25px -5px rgba(0, 0, 0, 0.1);
}

/* Container */
.zenify-container {
    z-index: 1050;
}

.zenify-container.popup-mode {
    width: 100vw;
    height: 100vh;
    overflow: hidden;
}

.zenify-container.popup-mode .dialer {
    position: static;
    width: 100%;
    height: 100vh;
    border-radius: 0;
    box-shadow: none;
    animation: none;
}

/* Main Dialer */
.dialer {
    position: fixed;
    bottom: 24px;
    right: 24px;
    width: 350px;
    height: 550px;
    background: var(--bg-primary);
    border-radius: 32px;
    box-shadow: 0 15px 40px rgba(15, 23, 42, 0.08),
                0 0 0 1px rgba(15, 23, 42, 0.03);
    overflow: hidden;
    display: flex;
    flex-direction: column;
    border: none;
    animation: slideUp 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
}

@keyframes slideUp {
    from {
        transform: translateY(30px) scale(0.95);
        opacity: 0;
    }
    to {
        transform: translateY(0) scale(1);
        opacity: 1;
    }
}

/* Header */
.dialer-header {
    background: linear-gradient(135deg, rgba(248, 250, 252, 0.6) 0%, rgba(255, 255, 255, 0.8) 100%);
    border-bottom: 1px solid rgba(226, 232, 240, 0.3);
    padding: 14px 16px;
    backdrop-filter: blur(10px);
    flex-shrink: 0;
}

.header-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 12px;
}

.user-section {
    display: flex;
    align-items: center;
    gap: 12px;
    flex: 1;
}

.user-avatar {
    font-size: 26px;
    color: var(--primary);
    flex-shrink: 0;
}

.user-details {
    min-width: 0;
}

.user-name {
    font-size: 12px;
    font-weight: 600;
    color: var(--text-primary);
    margin: 0;
    line-height: 1.2;
    letter-spacing: -0.2px;
}

.status-indicator {
    display: flex;
    align-items: center;
    gap: 6px;
    margin-top: 4px;
}

.status-dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: var(--success);
    animation: pulse-dot 2s ease-in-out infinite;
}

@keyframes pulse-dot {
    0%, 100% { opacity: 1; }
    50% { opacity: 0.6; }
}

.status-text {
    font-size: 10px;
    color: var(--success);
    font-weight: 500;
}

.close-btn {
    width: 32px;
    height: 32px;
    border-radius: 10px;
    background: linear-gradient(135deg, rgba(241, 245, 249, 0.4) 0%, rgba(226, 232, 240, 0.4) 100%);
    border: 1px solid rgba(226, 232, 240, 0.4);
    color: var(--text-secondary);
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    transition: all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
    flex-shrink: 0;
    backdrop-filter: blur(4px);
}

.close-btn:hover {
    background: linear-gradient(135deg, rgba(37, 99, 235, 0.1) 0%, rgba(96, 165, 250, 0.12) 100%);
    color: var(--text-primary);
    border-color: rgba(37, 99, 235, 0.2);
    transform: translateY(-1px);
}

.close-btn:active {
    transform: scale(0.94);
}

/* Content */
.dialer-content {
    flex: 1;
    overflow-y: auto;
    overflow-x: hidden;
}

.dialer-content::-webkit-scrollbar {
    width: 6px;
}

.dialer-content::-webkit-scrollbar-track {
    background: transparent;
}

.dialer-content::-webkit-scrollbar-thumb {
    background: var(--border-color);
    border-radius: 3px;
}

.dialer-content::-webkit-scrollbar-thumb:hover {
    background: var(--text-tertiary);
}

/* Keypad Section */
.keypad-section {
    padding: 18px 16px;
    display: flex;
    flex-direction: column;
    gap: 14px;
    overflow-y: auto;
    overflow-x: hidden;
}

.keypad-section::-webkit-scrollbar {
    width: 4px;
}

.keypad-section::-webkit-scrollbar-thumb {
    background: rgba(100, 116, 139, 0.3);
    border-radius: 2px;
}

.phone-display {
    background: linear-gradient(135deg, rgba(241, 245, 249, 0.5) 0%, rgba(248, 250, 252, 0.8) 100%);
    border-radius: 16px;
    padding: 14px 16px;
    display: flex;
    align-items: center;
    gap: 8px;
    position: relative;
    border: 1px solid rgba(226, 232, 240, 0.4);
    backdrop-filter: blur(4px);
}

.phone-prefix {
    font-size: 13px;
    font-weight: 600;
    color: var(--text-secondary);
    padding-right: 4px;
}

.phone-input {
    flex: 1;
    font-size: 18px;
    font-weight: 600;
    color: var(--text-primary);
    border: none;
    background: transparent;
    outline: none;
    text-align: center;
    letter-spacing: 1px;
    font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;
}

.phone-input::placeholder {
    color: var(--text-tertiary);
    letter-spacing: 0.5px;
    font-weight: 500;
    font-size: 14px;
}

.clear-btn {
    width: 34px;
    height: 34px;
    border-radius: 10px;
    background: linear-gradient(135deg, rgba(220, 38, 38, 0.12) 0%, rgba(239, 68, 68, 0.1) 100%);
    border: 1px solid rgba(220, 38, 38, 0.2);
    color: var(--danger);
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    transition: all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
}

.clear-btn:hover {
    background: linear-gradient(135deg, var(--danger) 0%, rgba(185, 28, 28, 0.95) 100%);
    color: white;
    border-color: var(--danger);
    transform: translateY(-2px);
}

.clear-btn:active {
    transform: scale(0.94);
}

/* Keypad Grid */
.keypad-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 10px;
}

.keypad-btn {
    min-height: 60px;
    background: linear-gradient(135deg, rgba(255, 255, 255, 0.6) 0%, rgba(248, 250, 252, 0.8) 100%);
    border: 1px solid rgba(226, 232, 240, 0.5);
    border-radius: 16px;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 4px;
    transition: all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
    font-family: inherit;
    background-clip: padding-box;
    backdrop-filter: blur(4px);
    padding: 4px;
}

.key-number {
    font-size: 20px;
    font-weight: 600;
    color: var(--primary);
    line-height: 1;
}

.key-letters {
    font-size: 8px;
    color: var(--text-tertiary);
    font-weight: 500;
    letter-spacing: 0.5px;
    text-transform: uppercase;
    line-height: 1;
}

.keypad-btn:hover {
    background: linear-gradient(135deg, var(--primary) 0%, rgba(37, 99, 235, 0.9) 100%);
    border-color: rgba(37, 99, 235, 0.4);
    color: white;
    transform: translateY(-6px);
    box-shadow: 0 12px 28px rgba(37, 99, 235, 0.15);
}

.keypad-btn:hover .key-number,
.keypad-btn:hover .key-letters {
    color: white;
}

.keypad-btn:active {
    transform: translateY(-2px) scale(0.98);
}

/* Call Controls */
.call-controls {
    display: flex;
    align-items: center;
    justify-content: space-around;
    gap: 10px;
    padding: 12px 8px;
}

.control-icon-btn {
    width: 42px;
    height: 42px;
    border-radius: 12px;
    background: linear-gradient(135deg, rgba(248, 250, 252, 0.6) 0%, rgba(241, 245, 249, 0.8) 100%);
    border: 1px solid rgba(226, 232, 240, 0.4);
    color: var(--text-secondary);
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    transition: all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
    backdrop-filter: blur(4px);
}

.control-icon-btn:hover {
    background: linear-gradient(135deg, rgba(37, 99, 235, 0.08) 0%, rgba(96, 165, 250, 0.12) 100%);
    color: var(--primary);
    border-color: rgba(37, 99, 235, 0.2);
    transform: translateY(-2px);
}

.call-action-btn {
    width: 56px;
    height: 56px;
    border-radius: 50%;
    background: linear-gradient(135deg, #10b981 0%, #059669 100%);
    border: none;
    color: white;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 22px;
    transition: all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
    box-shadow: 0 8px 20px rgba(5, 150, 105, 0.2);
}

.call-action-btn:hover:not(:disabled) {
    transform: translateY(-4px) scale(1.08);
    box-shadow: 0 12px 32px rgba(5, 150, 105, 0.25);
}

.call-action-btn:active {
    transform: translateY(-1px) scale(1.01);
}

.call-action-btn:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

/* Call Sections */
.call-section {
    display: flex;
    flex-direction: column;
    min-height: 460px;
    background: var(--bg-primary);
}

/* Call Header */
.call-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 14px 16px;
    background: linear-gradient(135deg, rgba(248, 250, 252, 0.4) 0%, rgba(255, 255, 255, 0.6) 100%);
    border-bottom: 1px solid rgba(226, 232, 240, 0.3);
    gap: 10px;
    backdrop-filter: blur(8px);
    flex-shrink: 0;
}

.call-title {
    font-size: 14px;
    font-weight: 600;
    color: var(--text-primary);
    margin: 0;
}

.call-timer {
    display: flex;
    align-items: center;
    gap: 4px;
    padding: 6px 10px;
    background: linear-gradient(135deg, rgba(248, 250, 252, 0.6) 0%, rgba(241, 245, 249, 0.8) 100%);
    border-radius: 10px;
    font-size: 11px;
    font-weight: 600;
    color: var(--text-secondary);
    border: 1px solid rgba(226, 232, 240, 0.4);
    backdrop-filter: blur(4px);
    flex-shrink: 0;
}

.call-timer i {
    font-size: 10px;
}

.call-timer.duration {
    background: linear-gradient(135deg, rgba(37, 99, 235, 0.08) 0%, rgba(96, 165, 250, 0.12) 100%);
    color: var(--primary);
    border-color: rgba(37, 99, 235, 0.2);
}

/* Via Info */
.via-info {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 10px 16px;
    background: linear-gradient(135deg, rgba(248, 250, 252, 0.4) 0%, rgba(241, 245, 249, 0.6) 100%);
    border-bottom: 1px solid rgba(226, 232, 240, 0.3);
    font-size: 11px;
    backdrop-filter: blur(4px);
    flex-shrink: 0;
}

.via-label {
    color: var(--text-secondary);
    font-weight: 500;
}

.via-number {
    color: var(--text-primary);
    font-weight: 600;
    font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;
    letter-spacing: 0.3px;
    word-break: break-all;
}

/* Call Info Block */
.call-info-block {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 24px 18px;
    background: linear-gradient(135deg, rgba(102, 126, 234, 0.92) 0%, rgba(118, 75, 162, 0.92) 100%);
    color: white;
    text-align: center;
    backdrop-filter: blur(10px);
    overflow-y: auto;
}

.call-section.incoming .call-info-block {
    background: linear-gradient(135deg, rgba(102, 126, 234, 0.92) 0%, rgba(118, 75, 162, 0.92) 100%);
}

.call-section.active .call-info-block {
    background: linear-gradient(135deg, rgba(102, 126, 234, 0.92) 0%, rgba(118, 75, 162, 0.92) 100%);
}

.caller-avatar-large {
    width: 85px;
    height: 85px;
    border-radius: 50%;
    margin-bottom: 16px;
    overflow: hidden;
    border: 3px solid rgba(255, 255, 255, 0.25);
    flex-shrink: 0;
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
}

.caller-avatar-large img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.caller-avatar-large.pulse {
    animation: pulse-avatar 2.5s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}

@keyframes pulse-avatar {
    0%, 100% {
        box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15), 0 0 0 0 rgba(255, 255, 255, 0.3);
    }
    50% {
        box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15), 0 0 0 12px rgba(255, 255, 255, 0);
    }
}

.calling-status {
    font-size: 12px;
    opacity: 0.88;
    margin: 0 0 8px 0;
    font-weight: 500;
    letter-spacing: 0.2px;
}

.caller-number {
    font-size: 20px;
    font-weight: 600;
    margin: 0 0 8px 0;
    letter-spacing: 0px;
    font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;
    word-break: break-all;
}

.caller-details {
    font-size: 12px;
    opacity: 0.8;
    margin: 0;
    font-weight: 500;
}

.wait-info {
    font-size: 11px;
    opacity: 0.8;
    margin: 4px 0 0 0;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
    font-weight: 500;
}

.wait-info i {
    font-size: 10px;
}

/* Call Actions */
.call-actions-group {
    display: flex;
    justify-content: center;
    gap: 10px;
    padding: 16px;
    background: linear-gradient(135deg, rgba(248, 250, 252, 0.4) 0%, rgba(241, 245, 249, 0.6) 100%);
    backdrop-filter: blur(8px);
    border-top: 1px solid rgba(226, 232, 240, 0.3);
    flex-shrink: 0;
}

.action-btn {
    flex: 1;
    height: 48px;
    border-radius: 12px;
    border: none;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    font-weight: 600;
    font-size: 12px;
    transition: all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
    font-family: inherit;
    padding: 0 8px;
}

.action-btn.decline {
    background: linear-gradient(135deg, rgba(220, 38, 38, 0.95) 0%, rgba(185, 28, 28, 0.95) 100%);
    color: white;
    box-shadow: 0 8px 20px rgba(220, 38, 38, 0.18);
}

.action-btn.decline:hover {
    transform: translateY(-4px);
    box-shadow: 0 12px 32px rgba(220, 38, 38, 0.25);
}

.action-btn.accept {
    background: linear-gradient(135deg, rgba(5, 150, 105, 0.95) 0%, rgba(4, 120, 87, 0.95) 100%);
    color: white;
    box-shadow: 0 8px 20px rgba(5, 150, 105, 0.18);
}

.action-btn.accept:hover {
    transform: translateY(-4px);
    box-shadow: 0 12px 32px rgba(5, 150, 105, 0.25);
}

.action-btn.end-call {
    background: linear-gradient(135deg, rgba(220, 38, 38, 0.95) 0%, rgba(185, 28, 28, 0.95) 100%);
    color: white;
    box-shadow: 0 8px 20px rgba(220, 38, 38, 0.18);
}

.action-btn.end-call:hover {
    transform: translateY(-4px);
    box-shadow: 0 12px 32px rgba(220, 38, 38, 0.25);
}

.action-btn:active {
    transform: scale(0.98);
}

/* Responsive */
@media (max-width: 480px) {
    .dialer {
        position: fixed;
        bottom: 16px;
        right: 16px;
        left: 16px;
        width: auto;
        max-width: none;
        max-height: calc(100vh - 32px);
        border-radius: 28px;
    }

    .dialer-header {
        padding: 16px 20px;
    }

    .keypad-section {
        padding: 24px 20px;
        gap: 20px;
    }

    .phone-display {
        padding: 16px 18px;
        border-radius: 18px;
    }

    .phone-input {
        font-size: 22px;
        letter-spacing: 1px;
    }

    .keypad-grid {
        gap: 12px;
    }

    .keypad-btn {
        min-height: 66px;
        border-radius: 18px;
    }

    .key-number {
        font-size: 22px;
    }

    .key-letters {
        font-size: 9px;
    }

    .call-controls {
        gap: 14px;
        padding-bottom: 6px;
    }

    .control-icon-btn {
        width: 46px;
        height: 46px;
        font-size: 16px;
    }

    .call-action-btn {
        width: 60px;
        height: 60px;
        font-size: 24px;
    }

    .call-info-block {
        padding: 32px 20px;
    }

    .caller-avatar-large {
        width: 95px;
        height: 95px;
        margin-bottom: 18px;
    }

    .caller-number {
        font-size: 24px;
        margin-bottom: 10px;
    }

    .calling-status,
    .caller-details {
        font-size: 13px;
    }

    .call-actions-group {
        gap: 10px;
        padding: 20px;
    }

    .action-btn {
        font-size: 13px;
        height: 50px;
        border-radius: 14px;
        gap: 8px;
    }

    .action-btn i {
        font-size: 18px;
    }

    .via-info {
        padding: 12px 20px;
        font-size: 12px;
    }

    .call-header {
        padding: 16px 20px;
    }

    .call-title {
        font-size: 15px;
    }

    .call-timer {
        font-size: 11px;
        padding: 6px 12px;
    }
}
</style>
